// @ts-check
import { ModuleProcessMappings } from '@erpagroapp/common';
import {
  ConfigurationParameterReturnType,
  ConfigurationParameterSource,
} from '../enums';
import { defineConfig, defineDefaultProps } from '../helpers';

const defaultProps = defineDefaultProps(/** @type {const} */ ({
  loadingRules: {
    requiredModuleIds: [
      ModuleProcessMappings.ProductionControl.Id,
    ],
    requiredProcessIds: [
      ModuleProcessMappings.ProductionControl.Processes.Dumping.Id,
    ],
  },
}));

export function dumping() {
  return defineConfig({
    ActualizarLineasNumeroSerieVolcado: {
      source: ConfigurationParameterSource.ERP,
      component: 'TrazabilidadAutomatizada',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    ComprobarCompatibilidadVolcadoAPedido: {
      source: ConfigurationParameterSource.WebService,
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    ImprimirEtiquetaRecuperadoVolcado: {
      source: ConfigurationParameterSource.WebService,
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    RegistrarDestrioEnVolcado: {
      source: ConfigurationParameterSource.ERP,
      component: 'TrazabilidadAutomatizada',
      useCaseCode: 'TRAUT900',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    ValidarPartidasAnterioresVolcado: {
      source: ConfigurationParameterSource.WebService,
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
  });
}
